import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../App.css";
import { decodeToken } from "react-jwt";
import { Card, Form, Button, Image, Alert, Spinner } from "react-bootstrap";

export default function LoginCard({ setIsTrue, tokenCheck }, props) {
  const [id, setID] = useState("");
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const [isValidated, setisValidated] = useState("");

  useEffect(() => {
    if (localStorage.getItem("userToken")) {
      axios
        .post("https://secretsafe-backend.onrender.com/vertify-token", {
          token: localStorage.getItem("userToken"),
        })
        .then((response, err) => {
          if (err) {
          } else {
            window.location.replace("/");
          }
        });
    }
  }, []);

  document.title = "Login | SecretSafe";

  function logIn(event) {
    event.preventDefault();
    axios
      .post("https://secretsafe-backend.onrender.com/login", {
        id,
        pin,
      })
      .then((response) => {
        if (response.data.error) {
          setShow(true);
          setError(response.data.error);
        } else {
          setShow(false);
          if (response.data.response) {
            localStorage.setItem("userToken", response.data.response);
            setIsTrue(true);
            window.location.replace("/");
          }
        }
      });
  }

  if (props.isTrue) {
    window.location.replace("/");
  }

  return (
    <Card
      style={{ alignItems: "center", padding: "15px", marginTop: "10px" }}
      className="mx-auto card__"
    >
      {props.isLoading ? (
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      ) : (
        <>
          <Card.Body
            style={{
              fontWeight: "800",
              fontSize: "25px",
              textAlign: "center",
              paddingBottom: "0px",
            }}
          >
            Login into your account
          </Card.Body>
          <hr style={{ width: "100%" }} />
          <Alert show={show} variant="danger">
            {error}
          </Alert>
          <Card style={{ width: "100%", marginTop: "10px", border: "none" }}>
            <Form>
              <Form.Group>
                <Form.Text style={{ fontSize: "16px", color: "#000" }}>
                  Your ID
                </Form.Text>
                <Form.Control
                  required
                  maxLength={8}
                  value={id}
                  onChange={(value) => setID(value.target.value)}
                  placeholder="Enter user ID"
                  style={{ marginRight: "40px", border: "3px #7F7CAF solid" }}
                />
                <Form.Text>
                  Note: Your ID is case-sensitive. For example, if your ID is{" "}
                  <code>gfyJSeYa</code>, then if you enter{" "}
                  <code>
                    gfy<b>js</b>e<b>y</b>a
                  </code>
                  , it won't work
                </Form.Text>
              </Form.Group>
              <Form.Group style={{ marginTop: "20px" }}>
                <Form.Text style={{ fontSize: "16px", color: "#000" }}>
                  Your PIN
                </Form.Text>
                <Form.Control
                  required
                  maxLength={10}
                  value={pin}
                  onChange={(value) => setPin(value.target.value)}
                  placeholder="Enter user PIN"
                  style={{ marginRight: "40px", border: "3px #7F7CAF solid" }}
                />
              </Form.Group>
              {isValidated ? (
                <Form.Text style={{ color: "#dc3545", textAlign: "center" }}>
                  Your name should be longer than 1 character
                </Form.Text>
              ) : (
                <></>
              )}
              <Button
                style={{
                  marginTop: "5px",
                  width: "100%",
                  background: "#7F7CAF",
                  border: "none",
                }}
                onClick={(e) => {
                  logIn(e);
                }}
              >
                Login
              </Button>
            </Form>
            <p style={{ paddingTop: "10px" }}>
              Don't Have an account?{" "}
              <a href="/" style={{ textDecoration: "none" }}>
                Create an Account
              </a>
            </p>
            <hr style={{ width: "100%" }} />
            <p style={{ paddingTop: "10px", textAlign: "left" }}>
              Lost Pin? Please create a new account. Forgot ID? It is at the end
              of your shared Link.
            </p>
            <p style={{ paddingTop: "10px", textAlign: "left" }}>
              Example: <br /> If your link is - <br />{" "}
              <code>https://secretsafe.rf.gd/msg/gfyJSeYa</code>
            </p>
            <p style={{ paddingTop: "10px", textAlign: "left" }}>
              Then your id will be - <br /> <code>gfyJSeYa</code>
            </p>
          </Card>
        </>
      )}
    </Card>
  );
}
